/**
 * Downloads a file from a URL with a specified filename using a hidden clickable link
 * This method bypasses CORS issues by using the browser's native download mechanism
 * @param url - The URL to download from (presigned URL)
 * @param filename - The filename to save as
 */
export const downloadFileFromUrl = async (
  url: string,
  filename: string
): Promise<void> => {
  try {
    // Create a hidden anchor element
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    // Add to DOM, click, then remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Give the browser a moment to process the download
    await new Promise((resolve) => setTimeout(resolve, 100));
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error(
      `Failed to download file: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }
};

/**
 * Generates a filename for the processed quote file
 * @param originalFilename - The original uploaded filename
 * @param quoteNumber - The quote number
 * @returns Generated filename
 */
export const generateQuoteFilename = (
  originalFilename: string,
  quoteNumber: string
): string => {
  const nameWithoutExtension = originalFilename.replace(/\.[^/.]+$/, '');
  const timestamp = new Date().toISOString().slice(0, 10); // YYYY-MM-DD format
  return `${nameWithoutExtension}_Quote_${quoteNumber}_${timestamp}.xlsx`;
};
